module.exports = __webpack_public_path__ + "img/page2.d6d11146.png";